import {Stack, Skeleton, TableRow as MuiTableRow, TableCell as MuiTableCell} from '@mui/material';

export function TableLoading({size = 40, gap = '16.4px'}: {size?: number; gap?: string}) {
  return (
    <MuiTableRow>
      <MuiTableCell colSpan={100}>
        <Stack gap={gap}>
          <Skeleton animation="wave" sx={{transform: 'scale(1, 0.78)'}} height={size} />
          <Skeleton animation="wave" sx={{transform: 'scale(1, 0.78)'}} height={size} />
          <Skeleton animation="wave" sx={{transform: 'scale(1, 0.78)'}} height={size} />
          <Skeleton animation="wave" sx={{transform: 'scale(1, 0.78)'}} height={size} />
          <Skeleton animation="wave" sx={{transform: 'scale(1, 0.78)'}} height={size} />
          <Skeleton animation="wave" sx={{transform: 'scale(1, 0.78)'}} height={size} />
        </Stack>
      </MuiTableCell>
    </MuiTableRow>
  );
}
